import LegalLayout from "@/components/LegalLayout";
import { COMPANY } from "@/lib/content";

export default function AccessibilityPage() {
  const sections = [
    {
      heading: "Our commitment",
      paragraphs: [
        "Amanah Promotions is committed to making this website accessible to as many people as possible, regardless of ability or the technology they use.",
      ],
    },
    {
      heading: "Standards we aim for",
      paragraphs: [
        "We aim to meet the Web Content Accessibility Guidelines (WCAG) 2.1 at level AA as a working target for this website. This is a working target and not a claim of formal conformance.",
      ],
    },
    {
      heading: "Accessibility features",
      paragraphs: ["This website has been built with accessibility in mind, including:"],
      list: [
        "Semantic HTML structure and clear headings",
        "Keyboard navigation and visible focus states",
        "Strong colour contrast against our navy and green palette",
        "Descriptive labels and clear error messages on all forms",
        "Support for reduced-motion preferences",
      ],
    },
    {
      heading: "Known limitations",
      paragraphs: [
        "We are not currently aware of any material accessibility limitations on this website, and we continue to review and improve accessibility. If you experience any difficulty, please let us know using the details below.",
      ],
    },
    {
      heading: "Feedback",
      paragraphs: [
        `If you experience any difficulty using this website, or need information in an alternative format, please contact us at ${COMPANY.email} and we will do our best to help.`,
      ],
    },
  ];

  return (
    <LegalLayout
      eyebrow="Legal"
      title="Accessibility Statement"
      intro="Our commitment to keeping the Amanah Promotions website usable for everyone."
      updated="8 August 2026"
      sections={sections}
    />
  );
}
